import { render, staticRenderFns } from "./ContentTabs.vue?vue&type=template&id=09d4e74d&scoped=true"
import script from "./ContentTabs.vue?vue&type=script&lang=js"
export * from "./ContentTabs.vue?vue&type=script&lang=js"
import style0 from "./ContentTabs.vue?vue&type=style&index=0&id=09d4e74d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d4e74d",
  null
  
)

export default component.exports